import type { PermissionCode } from '@/shared/permissions';

/**
 * Catalog permission codes — mirror the BFF's `RolePermissionMapper`:
 *  - `catalog.view` / `catalog.manage` — products, categories, media, import, search
 *  - `catalog.pricing.view` / `catalog.pricing.manage` — price governance
 *
 * Note: this is the `catalog.*` namespace, distinct from the `settings.catalog.*`
 * settings domain. `settings.*` does NOT grant these.
 */
export const CATALOG_PERMISSIONS = {
  catalog: { view: 'catalog.view', manage: 'catalog.manage' },
  pricing: { view: 'catalog.pricing.view', manage: 'catalog.pricing.manage' },
} as const satisfies Record<string, Record<string, PermissionCode>>;

export type CatalogPermissionArea = keyof typeof CATALOG_PERMISSIONS;

/** Flattened list of every catalog permission code (for mock sessions / seeding). */
export const ALL_CATALOG_PERMISSIONS: PermissionCode[] = Object.values(CATALOG_PERMISSIONS).flatMap(
  (area) => Object.values(area),
);
